import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeGenderFromText'
})
export class RemoveGenderFromTextPipe implements PipeTransform {

  transform(value: string | null | undefined): string {
    if (!value) return '';

    return value
      .replace(/\b(masculino|masculina|feminino|feminina|misto|mista)\b/gi, '')
      .replace(/\s{2,}/g, ' ')
      .trim();
  }
}
